import { Button, InPageNotification } from "@ebsco-ui/ebsco-ui";
import React, { useState } from "react";
import { injectIntl } from "react-intl";
import { useSelector } from "react-redux";
import getIsCoppa from "../../../store/coppa";
import AreYouSureDeleteModal from "../../are-you-sure-delete-modal";
import SubSection from "../sub-section";
import messages from "./account-removal-messages";
import { getRoles } from "../../../store/personal-user";
import "./account-removal.scss";

const block = "account-removal";

const AccountRemovalWithFlagOn = ({ intl: { formatMessage } }) => {
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const isCoppa = useSelector(getIsCoppa);
  const adminRoles = useSelector(getRoles);

  const handleDeleteModalClose = () => {
    setIsDeleteModalOpen(false);
  };

  const handleDeleteModalOpen = () => {
    if (adminRoles && adminRoles.length > 0) {
      window.open(
        "https://connect.ebsco.com/s/article/EBSCO-Experience-Manager-Administrators-Managing-your-MyEBSCO-account-data-and-privacy",
        "_blank",
        "noopener noreferrer"
      );
    } else setIsDeleteModalOpen(true);
  };

  const customMessages = isCoppa
    ? {
        headerText: messages.removePrivateDataWithFlag,
        explanation: messages.removeMyEbscoDataExplanation,
        folders: messages.folders
      }
    : {
        headerText: messages.removePrivateDataWithFlag,
        explanation: messages.explanationWithFlag,
        folders: messages.personalFoldersWithFlag
      };

  return (
    <>
      <SubSection
        className={`${block}__information`}
        headerText={formatMessage(customMessages.headerText)}
      >
        <InPageNotification
          variant="information"
          className={`${block}__notification`}
        >
          <h4 className={`${block}__rightToBeForgottenHeader`}>
            {formatMessage(messages.rightToBeForgottenWithFlag)}
          </h4>
          <InPageNotification.Description>
            {formatMessage(customMessages.explanation)}
          </InPageNotification.Description>
        </InPageNotification>
      </SubSection>
      <SubSection
        className={`${block}__action`}
        headerText={formatMessage(messages.permanentRemovalWarningWithFlag)}
      >
        <ul className={`${block}__list`}>
          <li>{formatMessage(customMessages.folders)}</li>
          <li>{formatMessage(messages.accountRemovalWithFlag)}</li>
          <li>{formatMessage(messages.monitoringHistory)}</li>
        </ul>
        <Button
          className={`${block}__button`}
          styleType="solid"
          onClick={handleDeleteModalOpen}
        >
          {formatMessage(messages.deleteAccount)}
        </Button>
        <AreYouSureDeleteModal
          onClose={handleDeleteModalClose}
          isOpen={isDeleteModalOpen}
        />
      </SubSection>
    </>
  );
};

export { AccountRemovalWithFlagOn };
export default injectIntl(AccountRemovalWithFlagOn);
